import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allow, requireCompany = true }) {
  const { user, company, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <div className="spinner-border text-primary" role="status" data-testid="loading-spinner">
          <span className="visually-hidden">Загрузка…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireCompany && !company && location.pathname !== "/create-company") {
    return <Navigate to="/create-company" replace />;
  }
  if (allow && !allow.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
